import * as XLSX from "xlsx";
import { PiFileXlsLight } from "react-icons/pi";

const ExportToExcel = ({ onClick }) => {
  const handleExport = () => {
    // Export logic can be defined here or passed through onClick
  };

  const handleClick = (event) => {
    if (onClick) onClick(event);
    handleExport();
  };

  return (
    <div
      style={{
        color: "#3D8C29",
        padding: "8px 16px",
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
      }}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter") handleClick(e);
      }}
    >
      <span
        onClick={handleClick}
        style={{ display: "inline-flex", alignItems: "center" }}
      >
        <PiFileXlsLight style={{ marginRight: "8px", fontSize: "24px" }} />
        Export To Excel
      </span>
    </div>
  );
};

export default ExportToExcel;
